export enum EstadoCidadeTypes {
  'LOAD_ESTADO_REQUEST' = '@estado/LOAD_ESTADO_REQUEST',
  'LOAD_ESTADO_SUCCESS' = '@estado/LOAD_ESTADO_SUCCESS',
  'LOAD_ESTADO_FAILURE' = '@estado/LOAD_ESTADO_FAILURE',

  'LOAD_CIDADE_REQUEST' = '@cidade/LOAD_CIDADE_REQUEST',
  'LOAD_CIDADE_SUCCESS' = '@cidade/LOAD_CIDADE_SUCCESS',
  'LOAD_CIDADE_FAILURE' = '@cidade/LOAD_CIDADE_FAILURE',

  'STATE_SELECT' = '@state/STATE_SELECT',

  'CITY_SELECT' = '@city/CITY_SELECT',

  'NAME_SELECT' = '@name/NAME_SELECT',

  'NAME_PARC_SELECT' = '@name/NAME_PARC_SELECT',

  'CNPJ_SELECT' = '@cnpj/CNPJ_SELECT',

  'CNPJ_AUTO_COMP' = '@cnpj/CNPJ_AUTO_COMP',

  'CLEAN' = '@estadoCidade/CLEAN',
}

export interface ICidade {
  codCid: number;
  codUf: IEstado;
  nome: string;
  siglaEstado: string;
  estado: string;
}

export interface IEstado {
  codUf: number;
}

export interface IEstadoSelecionado {
  codUf: number;
}

export interface ICidadeSelecionada {
  codCid: number;
}
export interface ICnpjSelecionado {
  codCid: number;
}
export interface EstadoCidadeState {
  readonly data: ICidade[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly estado: IEstado[];
  readonly estadoSelecionado?: IEstadoSelecionado;
  readonly cidadeSelecionada?: string | number;
  readonly nomeSelecionado?: string | number;
  readonly nomeParcSelecionado?: any;
  readonly cnpjSelecionado?: string | number;
  readonly cnpjAutoCompSelecionado?: string | number;
}
